<template lang='pug'>
#schedule
	#schedule-anchor
	h2.header Dagskrá
	.table
		.section
			.sub-header
				h3 Föstudagur
				h4 19. júlí
				.underline
			.items
				.item
					.time 16:00 - 18:00
					.event
						strong Krakkasápubolti
						br
						| Ekki þarf að skrá börn, bara mæta og taka þátt. (Aldursskipt verður á völlum og krakkar undir 10 ára þurfa að vera í fylgd með forráðamönnum).
				.item
					.time 23:00 - 03:00
					.event
						strong Stuðlabandið í Tjarnarborg.
						br
						| Ein skemmtilegasta hljómsveit landsins spilar inn Sápuboltahelgina.
				img.underline(src='@/assets/red_wave.svg')
		.section
			.sub-header
				h3 Laugardagur
				h4 20. júlí
				.underline
			.items
				.item
					.time 11:30
					.event
						strong Skrúðganga keppenda.
						br
						| Farið er frá Barnaskólanum (við hliðina á sundlauginni). Takið þátt í stystu skrúðgöngu landsins!
				.item
					.time 12:00
					.event
						strong Sápuboltamótið 2024 hefst.
						br
						| Keppni í sápuboltanum 2024 hefst á hóteltúninu og keppt verður fram eftir degi.
				.item
					.time 16:30
					.event
						strong Úrslitaleikur Sápuboltans 2024.
						br
						| Slökkvilið Fjallabyggðar mætir og dælir froðu á leikmenn og völlinn
				.item
					.time 20:00 - 22:00
					.event
						strong Útiskemmtun við Tjarnarborg.
						br
						| Verðlaun veitt fyrir afrek dagsins. Brekkusöngur verður svo haldinn.
				.item
					.time 23:00 - 03:00
					.event
						strong Lokapartý Sápuboltans.
						br
						| Við skellum svo í eitt rosalegasta partý norðan heiða í Tjarnaborg. Háski, Séra Bjössi, Patriik (Prettyboitjokko), Birnir og Daniil.
					img.underline(src='@/assets/red_wave.svg')
	.additional
		.underline
		p *Frekari upplýsingar verða veittar á <a href='https://www.facebook.com/sapuboltamot/' target='_blank'>facebook</a> síðu okkar
		p *Með fyrirvara um breytingar
</template>

<script>
export default {
	name: 'Schedule'
};
</script>

<style lang="less">
	.VueCarousel-pagination {
		position: absolute;
	}
	.VueCarousel-dot {
		button {
			transition: .3s;
		}
	}
	.VueCarousel-dot--active {
		button {
			background-color: #f3736b !important;
		}
	}
</style>

<style lang="less" scoped>
#schedule {
	#schedule-anchor {
		width: 100vw;
		height: 5px;
		position: absolute;
		top: -150px;
	}
	position: relative;
	z-index: 1;
	background-color: #118acd;
	@media screen and (max-width: 638px) {
		transform: translateY(-38px);
	}
	.additional {
		.underline {
			width: 100%;
			max-width: 200px;
			height: 3px;
			background-color: #f3736b;
		}
		a {
			color: #f3736b;
			text-decoration: none;
			font-weight: bold;
			transition: .3s;
			border-radius: 10px;
			&:hover {
				padding-left: 5px;
				padding-right: 5px;
				background-color: white;
			}
		}
		margin-left: 167px;
		margin-right: 167px;
		padding-bottom: 48px;
		color: #f6e0d6;
		@media screen and (max-width: 1200px) {
			margin-left: 71px;
			margin-right: 71px;
		}
		@media screen and (max-width: 530px) {
			margin-left: 31px;
			margin-right: 31px;
		}
	}
	.header {
		color: #f6e0d6;
		font-size: 40px;
		font-weight: bold;
		text-align: center;
		padding-top: 75px;
		padding-bottom: 50px;
		@media screen and (max-width: 1300px) {
			padding-bottom: 0px;
		}
	}
	.table {
		padding-left: 171px;
		padding-right: 171px;
		margin-left: auto;
		margin-right: auto;
		@media screen and (max-width: 1200px) {
			padding-left: 71px;
			padding-right: 71px;
		}
		@media screen and (max-width: 768px) {
			padding-left: 0px;
			padding-right: 0px;
		}
		.section {
			display: grid;
			grid-template-columns: 1fr 1fr;
			@media screen and (max-width: 768px) {
				grid-template-columns: 1fr;
			}
			grid-gap: 48px;
			margin-bottom: 64px;
			.sub-header {
				h4 {
					margin: 0px;
					margin-top: 8px;
					padding: 0px;
					font-weight: bold;
					font-style: normal;
					font-stretch: normal;
					line-height: normal;
					letter-spacing: normal;
					color: #f6e0d6;
					text-align: right;
					@media screen and (max-width: 768px) {
						text-align: center;
					}
				}
				h3 {
					margin: 0px;
					padding: 0px;
					font-size: 24px;
					font-weight: bold;
					font-style: normal;
					font-stretch: normal;
					line-height: normal;
					letter-spacing: normal;
					color: #f6e0d6;
					text-align: right;
					@media screen and (max-width: 768px) {
						text-align: center;
					}
				}
				.underline {
					width: 100px;
					height: 4px;
					background-color: #f3736b;
					margin-top: 10px;
					float: right;
					@media screen and (max-width: 768px) {
						float: initial;
						margin-left: auto;
						margin-right: auto;
					}
				}
			}
			.items {
				max-width: 370px;
				@media screen and (max-width: 768px) {
					margin-left: auto;
					margin-right: auto;
				}
				@media screen and (max-width: 368px) {
					margin-left: 31px;
					margin-right: 31px;
				}
				.underline {
					margin-top: 24px;
					@media screen and (max-width: 768px) {
						display: block;
						width: 100px;
						margin-left: auto;
						margin-right: auto;
					}
					@media screen and (max-width: 368px) {
						display: block;
						width: 100px;
						margin-left: 12px;
					}
				}
				.item {
					display: grid;
					grid-template-columns: 130px 1fr;
					margin-bottom: 18px;
					@media screen and (max-width: 768px) {
						grid-template-columns: 1fr 1fr;
						grid-gap: 24px;
					}
					@media screen and (max-width: 368px) {
						grid-template-columns: 60px 1fr;
					}
					.time {
						color: #f6e0d6;
						font-size: 18px;
						font-weight: bold;
						text-align: left;
						@media screen and (max-width: 768px) {
							text-align: right;
						}
					}
					.event {
						color: #f6e0d6;
						font-size: 18px;
						text-align: left;
					}
				}
			}
		}
	}
}
</style>
